import React, { useState } from "react";
import { Form, Input, Button, Card, message } from "antd";
import { useNavigate, Link } from "react-router-dom";
import axiosInstance from "api/axiosInstance";
import API from "api/endpoints";

function Register() {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onFinish = async (values) => {
    try {
      setLoading(true);

      const payload = {
        firstName: values.firstName,
        lastName: values.lastName,
        email: values.email,
        mobileNo: values.mobileNo,
      };

      const response = await axiosInstance.post(API.candidate.register, payload);

      message.success("Registration successful!");
      navigate("/candidate-check-email");
    } catch (error) {
      console.error("Register error:", error);
      message.error(error?.response?.data?.message || "Registration failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        background: "#f5f5f5",
      }}
    >
      <Card title="Candidate Registration" style={{ width: 400 }}>
        <Form layout="vertical" onFinish={onFinish}>
          <Form.Item
            name="firstName"
            label="First Name"
            rules={[{ required: true, message: "First name is required" }]}
          >
            <Input placeholder="Enter first name" />
          </Form.Item>

          <Form.Item
            name="lastName"
            label="Last Name"
            rules={[{ required: true, message: "Last name is required" }]}
          >
            <Input placeholder="Enter last name" />
          </Form.Item>

          <Form.Item
            name="email"
            label="Email"
            rules={[
              { required: true, message: "Email is required" },
              { type: "email", message: "Enter valid email" },
            ]}
          >
            <Input placeholder="Enter email" />
          </Form.Item>

          <Form.Item
            name="mobileNo"
            label="Mobile Number"
            rules={[{ required: true, message: "Mobile number is required" }]}
          >
            <Input placeholder="Enter mobile number" />
          </Form.Item>

  

          <Form.Item style={{ marginTop: 24 }}>
            <Button
              className="btn-primary"
              htmlType="submit"
              block
              loading={loading}
              style={{ height: "40px" }}
            >
              Register
            </Button>
          </Form.Item>

          <div style={{ textAlign: "center" }}>
            Already have an account? <Link to="/empsignIn">Login</Link>
          </div>
        </Form>
      </Card>
    </div>
  );
}

export default Register;
